import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

import { Preferences } from '@capacitor/preferences';

import { AuthService } from '@core/auth/services/auth.service';

export const routeGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Promise<boolean> => {
  const authService = inject(AuthService);
  const isAuthenticated = await authService.checkAuthentication();

  if (isAuthenticated) return true;

  const redirectPath = state.url;
  await Preferences.set({
    key: 'REDIRECT_LOCATION',
    value: redirectPath,
  });

  await authService.goToLogin(route.queryParams);
  return false;
};
